<template>
    <div class="doctor-info">
        <h3 class="content-title" title="Аллергология" v-if="!no_title"> {{ data.title }} </h3>
        <div class="doctor-info__content">
            <div class="doctor-info__content-item" @click="showModalStatus(doctor.slug)" :key="doctor.id"
                 v-for="doctor in data.doctors">
                <img
                    :src="doctor.photo ? doctor.photo.crop : ''"
                    :alt="doctor.full_name">
                <div class="doctor-info__description">
                    <h3>{{ doctor.full_name }}</h3>
                    <h5 v-html="doctor.short_description"/>
                    <h5 v-if="doctor.academic_degree" v-html="doctor.academic_degree"/>
                    <h5 v-if="doctor.category" v-html="doctor.category"/>
                    <div v-if="doctor.is_department_head" class="doctor-info__main">
                        <h6>Заведующий отделением</h6>
                    </div>
                </div>
            </div>
        </div>

        <popup-component v-show="showModal && doctorDetail" v-model="showModal" @input="contactForm = false">
            <DoctorDetail v-if="doctorDetail && !contactForm" :data="doctorDetail" @openContact="openContact"/>
            <DoctorContactPage :formType="formType" :doctorSlug="doctorDetail.slug" v-if="doctorDetail && contactForm"
                               @close="contactForm = false"/>
        </popup-component>
    </div>
</template>

<script>
import PopupComponent from "../components/PopupComponent";
import DoctorDetail from "../components/DoctorDetail";
import DoctorContactPage from "@/components/DoctorContactPage";
import {mapActions} from "vuex";

export default {
    props: ["data", 'no_title'],
    components: {
        DoctorDetail,
        PopupComponent,
        DoctorContactPage,
    },
    data() {
        return {
            showModal: false,
            doctorDetail: null,
            contactForm: false,
            formType: 'sendFeedback',
        }
    },
    methods: {
        ...mapActions(["fetchDocotorsDetail"]),

        showModalStatus(slug) {

            this.fetchDocotorsDetail(slug).then(response => {
                this.doctorDetail = response.data;
            });

            this.showModal = true;
        },
        openContact(value) {
            this.formType = value;
            this.contactForm = true;
        },
    },
    watch: {
        showModal(value) {
            if (!value) {
                setTimeout(() => {
                    this.doctorDetail = null
                }, 200)
            }
        }
    },
    beforeDestroy() {
        this.doctorDetail = null;
    }
}
</script>

<style lang="scss" scoped>


.doctor-info {
    display: flex;
    flex-direction: column;
    padding-bottom: 60px;

    &__content-item {
        img {
            border-radius: 50%;
            width: 150px;
            height: 150px;
        }
    }

    &__image {
        width: 100%;
        /*img {*/
        /*    max-width: 300px*/
        /*}*/
    }

    &__content {
        padding-top: 30px;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
        grid-gap: 20px;
        cursor: pointer;
        grid-row-gap: 40px;
    }

    &__description {
        h3 {
            font: normal 14px/12px Arial, sans-serif;
            color: #131313;
            padding: 10px 0;
        }

        h5 {
            font: normal 12px/12px Arial, sans-serif;
            color: #666;
            line-height: 16px;
            padding: 5px 0;
        }

        p {
            font: normal 12px/12px Arial, sans-serif;
            color: #131313;
            padding: 10px 0;
            margin: 0;
        }
    }

    &__main {
        padding-top: 10px;

        h6 {
            font: normal 12px/12px Arial, sans-serif;
            color: #131313;
            display: flex;
            align-items: center;
            justify-content: center;

            &:before {
                content: '';
                display: block;
                margin-right: 10px;
                height: 12px;
                width: 3px;
                background: #00B6CC;


            }
        }
    }

}


</style>